import { FormattedMessage } from "react-intl"
import { Link } from "react-router-dom"

export const Pending = ({ isOrder, confirmation, title, isIBAN }: { confirmation: number; title?: string; isIBAN?: boolean; isOrder?: boolean }) => {
  const isIbanPending = /iban.*pending/gi.test(title ?? "")
  let msgText = !isOrder ? "the-deposit" : "Your card order is being processed."
  if (isIBAN) msgText = "the-deposit_iban"
  return (
    <div className="payment-confirmation">
      <h1 className="uppercase">{title ?? "Exchange Pending"}</h1>
      <p>
        <FormattedMessage id="blockchain" /> {confirmation ?? 0}
      </p>
      <div className="text-center">
        {isOrder ? (
          <p>
            You can track the current status of your request in the{" "}
            <span className="text-main-main">
              <Link to="/transactions/exchange" className="hover:!underline">
                Orders section
              </Link>
            </span>
            .
          </p>
        ) : (
          <p>
            * <FormattedMessage id={isIbanPending ? "iban-deposit-pending-text" : msgText} />
          </p>
        )}
        {!isOrder ? (
          <p>
            **{" "}
            <FormattedMessage
              id="order-section"
              values={{
                b: (chunk) => (
                  <span className="text-main-main">
                    <Link to="/transactions/exchange" className="hover:!underline">
                      {chunk}
                    </Link>
                  </span>
                ),
              }}
            />
          </p>
        ) : (
          <p>
            <p>Once the order is completed, your card details and next steps will become available in your account.</p>
          </p>
        )}
      </div>
    </div>
  )
}
